import { Button } from "@mui/material";

import { useFormik } from "formik";
import { useState } from "react";
import Flex from "../../../../../components/Flex";
import GlobalFilter from "../../../../../components/GlobalFilter";
import { ScrollArea } from "../../../../../components/ScrollBar";
import { useSpecialtiesList } from "../../../../../queries/use-specialities-list";
import {
  FilterAccordion,
  getInitialExpanded,
} from "../../../../../utils/util-components/UtilComponents";
import CustomSelectScroll from "@/components/CustomSelectScroll";
import ProviderSelectScroll from "@/components/ProviderSelectScroll";
import { useActiveComponentCountController } from "../../../../../components/filter/use-ActiveComponentCountController";
import { useDebounce } from "@/hooks/use-debounce";
import { DEF_PAGINATION, DGT_Pagination } from "@/utils/utils";

interface EducationMaterialFilterProps {
  onApply: (v: any) => void;
  filters: EducationMaterialFilterInitialValuesType;
  setFilter: (v: EducationMaterialFilterInitialValuesType) => void;
  starIcon?: React.ReactNode;
}

export type EducationMaterialFilterInitialValuesType = {
  uploaded_by: undefined;
  speciality: undefined;
};
export const DEFAULT_EDUCATION_MATERIAL_FILTER_VALUES = {
  uploaded_by: undefined,
  speciality: undefined,
};

const EducationMaterialFilter = ({
  onApply,
  filters,
  setFilter,
  starIcon,
}: EducationMaterialFilterProps) => {
  const formik = useFormik({
    initialValues: filters,
    onSubmit: (v) => onApply(v),
  });

  const [expanded, setExpanded] = useState<{ [k: string]: boolean }>(
    getInitialExpanded(Object.keys(formik.values))
  );

  function handleExpandClick(key: string) {
    const copiedData = { ...expanded };
    copiedData[key] = !copiedData[key];
    setExpanded(copiedData);
  }

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [specialtyPagination, setSpecialtyPagination] =
    useState<DGT_Pagination>(DEF_PAGINATION);
  const [specialtySearchKey, setSpecialtySearchKey] = useDebounce<string>("");
  const { data: specialtiesList, isFetching: specialtiesFetching } =
    useSpecialtiesList({
      enabled: !!anchorEl,
      pagination: specialtyPagination,
      searchString: specialtySearchKey,
    });
  const closeFilter = () => setAnchorEl(null);

  const activeFilterCount = useActiveComponentCountController(formik.values);
  return (
    <GlobalFilter
      anchorEl={anchorEl}
      setAnchorEl={setAnchorEl}
      activeFilterCount={activeFilterCount}
      starIcon={starIcon}
    >
      <Flex
        width={"18.438rem"}
        flexDirection={"column"}
        justifyContent={"space-between"}
      >
        <Flex width={"100%"} justifyContent={"end"}>
          <Button
            variant="text"
            onClick={() => {
              formik.setValues(DEFAULT_EDUCATION_MATERIAL_FILTER_VALUES);
              setFilter(DEFAULT_EDUCATION_MATERIAL_FILTER_VALUES);
              closeFilter();
            }}
          >
            Clear Filter
          </Button>
        </Flex>
        <ScrollArea height={"80%"}>
          {Object.keys(formik.values).map((key) => {
            return key === "uploaded_by" ? (
              <FilterAccordion
                k={key}
                expanded={expanded[key]}
                onExpand={handleExpandClick}
              >
                <ProviderSelectScroll
                  value={
                    formik.values[key as keyof typeof formik.values] || null
                  }
                  onChange={(val) => formik.setFieldValue(key, val)}
                />
              </FilterAccordion>
            ) : key === "speciality" ? (
              <FilterAccordion
                k={key}
                label="Specialty"
                expanded={expanded[key]}
                onExpand={handleExpandClick}
              >
                {/* <MaskMultiSelect
                  optionWithCheckbox={true}
                  value={formik.values[key as keyof typeof formik.values]}
                  placeholder={replaceUnderScoreAddSpace(key)}
                  options={specialtiesList?.data?.content?.map(
                    (specialty) => ({
                      value: specialty?.uuid,
                      label: specialty?.name,
                    })
                  )}
                  onChange={(val) => formik.setFieldValue(key, val)}
                /> */}
                <CustomSelectScroll
                  name="speciality"
                  value={formik.values?.speciality}
                  onChange={(val) => formik.setFieldValue("speciality", val)}
                  options={specialtiesList?.data?.content?.map((specialty) => ({
                    value: specialty?.uuid,
                    label: specialty?.name,
                  }))}
                  loading={specialtiesFetching}
                  pagination={specialtyPagination}
                  setPagination={setSpecialtyPagination}
                  totalElements={specialtiesList?.data?.page?.totalElements}
                  onSearch={(_e, val) => {
                    setSpecialtySearchKey(val);
                    setSpecialtyPagination((p) => ({ ...p, page: 0 }));
                  }}
                />
              </FilterAccordion>
            ) : null;
          })}
        </ScrollArea>
        <Flex width={"100%"} justifyContent={"end"}>
          <Button
            variant="text"
            sx={{ color: "gray" }}
            onClick={() => {
              closeFilter();
            }}
          >
            Cancel
          </Button>
          <Button
            variant="text"
            onClick={() => {
              formik.submitForm();
              closeFilter();
            }}
          >
            Apply
          </Button>
        </Flex>
      </Flex>
    </GlobalFilter>
  );
};

export default EducationMaterialFilter;
